import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {WordpressPostService} from '../../service/wordpress-post.service';
import {WordpressPost} from '../../domain/wordpress-post';
import {UserService} from '../../../core/service/user.service';
import {User} from '../../../core/domain/user';
import {Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {DocumentService} from '../../service/repository/document.service';
import {GlobalAppService} from '../../../core/commons/global-app.service';
import {Document as Doc, Document} from '../../domain/document';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {PdfViewerComponent} from '../repository/explorer/pdf-viewer/pdf-viewer.component';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import * as moment from 'moment/moment'

@Component({
    selector: 'app-home-fiscalia',
    templateUrl: './home-fiscalia.component.html',
    styleUrls: ['./home-fiscalia.component.scss'],
    providers: [WordpressPostService, UserService]
})
export class HomeFiscaliaComponent implements OnInit, OnDestroy {

    posts: Observable<WordpressPost[]>;
    showPlaceholder: BehaviorSubject<boolean> = new BehaviorSubject(true);
    contactos: Observable<User[]>;
    lastDocuments: Observable<Doc[]>;
    documentSelected: Doc;


    bigPostWordsLimit = 200;
    littePostWordsLimit = 50;

    constructor(
        private wordpressPostService: WordpressPostService,
        private documentService: DocumentService,
        private userService: UserService,
        private messageService: GlobalAppService,
        public dialog: MatDialog,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.lastDocuments = this.documentService.getLastDocuments();
        this.posts = this.wordpressPostService
            .getAll()
            .switchMap(
                post => {
                    this.showPlaceholder.next(false);
                    return Observable.of<WordpressPost[]>(post.slice(0, 3));
                }
            );
    }

    public setDocumentSelected(d: Doc): void {
        this.documentSelected = d;
        // console.log(d);
        this.viewDocument();
    }

    public viewDocument() {
        this.messageService.setLoading(true);
        this.documentService
            .downloadPDF(this.documentSelected.id.toString())
            .subscribe(res => {
                    let fileURL = URL.createObjectURL(res);
                    console.log(res);
                    this.openDialog(fileURL);
                },
                error => {
                    console.log(error);
                    this.messageService.setLoading(false);
                }
            );
    }

    openDialog(fileUrl: string): void {
        const dialogRef = this.dialog
            .open(PdfViewerComponent, {
                width: '100%',
                height: 'auto',
                data: {document: this.documentSelected, name: this.documentSelected.name, pdf: fileUrl, pdfLink: fileUrl}
            })
            .afterOpen()
            .subscribe(res => this.messageService.setLoading(false));
    }

    public getCreateTime(time: number): string {
        const date = moment(time);
        const days = date.diff(new Date(), 'days');
        if (days > -2) {
            return date.fromNow();
        }
        return date.format("L");
    }

    public goToPage(route: string []) {
        this.router.navigate(route);
    }

    ngOnDestroy(): void {
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/home-fiscalia/home-fiscalia.component.ts